import Alert from "@/components/Alert";
import { ErrorCode } from "react-dropzone-esm";
import { useTranslation } from "@/i18n/client";
import { TFunction } from "i18next";
import { ErrorCodeLocal } from "@/constants/attachment";

interface Props {
  code: string;
  name: string;
  onClose: () => void;
}

const isErrorCode = (code: string): code is ErrorCode | ErrorCodeLocal => {
  return Object.values(ErrorCode).includes(code) || Object.values(ErrorCodeLocal).includes(code);
};

const getErrorMessage = (code: ErrorCode | ErrorCodeLocal, t: TFunction<"common">) => {
  if (code === ErrorCode.FileInvalidType || code === ErrorCodeLocal.unsuportedJpegExtension) {
    return t("fileError.invalidType");
  }
  if (code === ErrorCode.FileTooLarge) {
    return t("fileError.tooLarge");
  }
  if (code === ErrorCode.TooManyFiles) {
    return t("fileError.tooManyFiles");
  }
  if (code === ErrorCodeLocal.alreadyLoading) {
    return t("fileError.alreadyLoaded");
  }
};

export const FileError = ({ code, name, onClose }: Props) => {
  const { t } = useTranslation("common");

  return (
    <Alert variant="error" onClose={onClose} closeButtonLabel={t("close")}>
      <>
        {name} {isErrorCode(code) ? getErrorMessage(code, t) : t("fileError.corrupted")}
      </>
    </Alert>
  );
};
